import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(38, 87, 158, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 50px 15px;
  overflow-y: auto;
  div {
    /*flex: 0 0 85%;
    min-width: 85%;*/
	display: flex;
	align-items: center;
	justify-content: center;
  }
  img {
    width: 100%;
    height: auto;
	max-height: 800px;
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  width: 43px;
  height: 43px;
  top: 0;
  right: 0;
  cursor: pointer;
  background-color: #fff;
  border: 0;
  margin-top: 40px;
  margin-right: 40px;
  /* background-color: #999; */
  border-radius: 50%;
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    /* background-color: rgba(245, 167, 160, 1); */
    background-color: #831d13;
    width: 60%;
    height: 4px;
    top: 50%;
    left: 50%;
  }
  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  @media (max-width: 992px) {
    margin: 0;
    width: 55px;
    height: 55px;
    &:before,
    &:after {
      width: 60%;
    }
  }
`;
